// TES-1109 — what the "Kontaktlista" page shows, kept free of React and of
// runtime imports so it can be unit-tested with plain `node --test`.
import type {
  ContactListChannel,
  ContactListConsent,
  OnboardingContactRow,
} from "@care-by-ella/contracts";
import { COHORT_STEP_LABEL } from "./onboarding-funnel";

export const CONTACT_CHANNEL_LABEL: Record<ContactListChannel, string> = {
  web: "Webben",
  app: "Appen",
  ig: "Instagram",
  email: "E-post",
};

/** An e-mail address is never consent: no record reads "Inget samtycke". */
export const CONTACT_CONSENT_LABEL: Record<ContactListConsent, string> = {
  granted: "Samtycke",
  withdrawn: "Återkallat",
  none: "Inget samtycke",
};

/** The filter options, "all" first, in the labels' order. */
export const CHANNEL_OPTIONS = Object.keys(
  CONTACT_CHANNEL_LABEL,
) as ContactListChannel[];
export const CONSENT_OPTIONS = Object.keys(
  CONTACT_CONSENT_LABEL,
) as ContactListConsent[];

/** A Stockholm day, YYYY-MM-DD. */
export function stockholmDay(iso: string): string {
  return new Intl.DateTimeFormat("sv-SE", {
    timeZone: "Europe/Stockholm",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date(iso));
}

export type ContactViewRow = {
  patientId: string;
  name: string;
  email: string;
  verified: string;
  lastStep: string;
  lastStepDay: string;
  lastActivityDay: string;
  channel: string;
  consent: string;
  consentDay: string | null;
  /** True only for a granted consent: the one state that allows contact. */
  mayContact: boolean;
};

export function contactViewRow(row: OnboardingContactRow): ContactViewRow {
  return {
    patientId: row.patientId,
    name: row.patientName,
    email: row.email,
    verified: row.emailVerified
      ? row.emailVerifiedAt
        ? `Ja, ${stockholmDay(row.emailVerifiedAt)}`
        : "Ja"
      : "Nej",
    lastStep: COHORT_STEP_LABEL[row.lastStep] ?? row.lastStep,
    lastStepDay: stockholmDay(row.lastStepAt),
    lastActivityDay: stockholmDay(row.lastActivityAt),
    channel: CONTACT_CHANNEL_LABEL[row.channel] ?? row.channel,
    consent: CONTACT_CONSENT_LABEL[row.feedbackConsent] ?? "Inget samtycke",
    consentDay: row.feedbackConsentAt
      ? stockholmDay(row.feedbackConsentAt)
      : null,
    mayContact: row.feedbackConsent === "granted",
  };
}
